export function productInit() {

    $(document).ready(() => {
        let slickProductPicture = $('#slick-product').slick({
            fade: true,
            swipe: false,
            adaptiveHeight: true
        });

        let slickProductInfo = $('#slick-product-info').slick({
            fade: true,
            swipe: false,
        });

        $('.page-product a.pill').on('click', function(e) {
            e.preventDefault();

            // Remove active class
            $('.page-product a.pill').removeClass('active');
            $(this).addClass('active');

            slickProductPicture.slick('slickGoTo', $(this).attr('data-slide'));
            slickProductInfo.slick('slickGoTo', $(this).attr('data-slide'));
        });
    });

    // Dropdown
    $('.custom-select-wrapper').on('click', function() {
        $('.custom-select-wrapper .custom-select').toggleClass('open');
    });

}